import { useTranslation } from "react-i18next";
import { Button } from "../components/styles/Button.styled";

const Thankyou = () => {
  const { t } = useTranslation("enrollment");
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        margin: "2rem 0",
      }}
    >
      <div style={{ maxWidth: "800px" }}>
        <h1 style={{ margin: "1.5rem 0" }}>
          Thank you for considering CleanSky Energy as your electricity
          provider. We appreciate your interest in our services and value the
          opportunity to serve you.
        </h1>
        <p style={{ marginTop: "1rem", fontSize: "1.2rem" }}>
          If you're still interested in choosing CleanSky Energy, you can easily
          restart the enrollment process by clicking the link below. This will
          guide you through the next steps to complete your enrollment.
        </p>
        <Button
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            window.location.href = `https://cleanskyenergy.com/`;
          }}
        >
          {t("Back to Homepage")}
        </Button>
        <p style={{ marginTop: "1.5rem", fontSize: "1.2rem" }}>
          Thank you again for your interest in CleanSky Energy. We look forward
          to the possibility of serving you in the future.
        </p>
      </div>
    </div>
  );
};

export default Thankyou;
